import React, { Component } from 'react'
import * as utils from "../../utils";
import * as common_utils from "../../../common/utils";

import TaggedGuestsModal from "./tagged-guests-modal";
import UserProfileLink from "../../common/components/user-profile-link";

const TagsCount = React.createClass({
  getInitialState() {
    return { isModalOpen: false };
  },
  render() {
    const { tags } = this.props;
    const hasTaggedUsers = tags.length > 0;

    if (!hasTaggedUsers) {
      return null;
    }
    return (
      <div className="tag-count">
        {this.tagStr()}
        { hasTaggedUsers &&
          <TaggedGuestsModal
            tags={tags}
            isModalOpen={this.state.isModalOpen}
            onClose={this.handleOnClose}
          />
        }
      </div>
    )
  },
  tagStr() {
    const { tags } = this.props;
    const tagCount = tags.length;
    return (
      <span>
        &mdash; with <UserProfileLink userId={tags[0].user_id} firstName={tags[0].name} />
        { tagCount > 1 &&
          <span>
            &&nbsp;
            { tagCount === 2 ?
              <UserProfileLink userId={tags[1].user_id} firstName={tags[1].name} />
              :
              <a href="#" onClick={this.handleClick}>
                {common_utils.pluralize("other", tagCount - 1)}
              </a>
            }
          </span>
        }
      </span>
    );
  },
  handleClick(e) {
    e.preventDefault();
    this.setState({
      isModalOpen: true
    });
  },
  handleOnClose() {
    this.setState({
      isModalOpen: false
    })
  }
});

export default TagsCount;



// WEBPACK FOOTER //
// ./assets/es6/view_invitation/posts/components/tags-count.es6